export const AVATAR_IMAGE_FALLBACK =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e8cbfae6a7a38e58d840bd58764288e5-1750681197583/brand-test-lohp-seller-avatar.png';
